import { useEffect, useRef, useState } from "react";

import { useLogout } from "../api/hooks";
import type { User } from "../api/types";

export function Topbar({
  user,
  railCollapsed,
  onToggleSidebar,
}: {
  user: User;
  railCollapsed?: boolean;
  onToggleSidebar: () => void;
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  const logout = useLogout();

  useEffect(() => {
    if (!menuOpen) return;
    const close = (event: MouseEvent) => {
      if (!wrapRef.current?.contains(event.target as Node)) setMenuOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [menuOpen]);

  return (
    <div id="topbar">
      <button
        className="icon-btn"
        id="sidebar-toggle"
        aria-label={railCollapsed ? "Agentenleiste einblenden" : "Agentenleiste ausblenden"}
        aria-expanded={!railCollapsed}
        aria-controls="sidebar"
        title={railCollapsed ? "Agentenleiste einblenden" : "Agentenleiste ausblenden"}
        onClick={onToggleSidebar}
      >
        ☰
      </button>
      <div className="brandmark">
        <img src="/logo.png" alt="Autoflug" className="brandlogo" />
      </div>
      <div className="spacer" />
      <div className="user-menu-wrap" ref={wrapRef}>
        <button
          className="user-avatar"
          id="user-avatar"
          aria-haspopup="true"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {user.initials}
        </button>
        <div className={`user-menu${menuOpen ? " open" : ""}`} id="user-menu">
          <div className="um-head">
            <span className="um-name">{user.full_name || user.email}</span>
            <span className="um-mail">{user.email}</span>
          </div>
          <button
            className="btn secondary um-logout"
            id="btn-logout"
            disabled={logout.isPending}
            onClick={() => logout.mutate()}
          >
            Abmelden
          </button>
        </div>
      </div>
    </div>
  );
}
